<template>
  <iframe
    ref="iframeRef"
    :style="{
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      position: 'absolute',
      opacity: 0
    }"
  />
</template>

<script lang="ts">
import { onBeforeUnmount, onMounted } from "vue";
import { PropType, defineComponent, ref, watchEffect } from "vue";

export default defineComponent({
  name: "ResizeListener",
  components: {},
  props: {
    onResize: {
      type: Function as PropType<
        ({
          width,
          height
        }: {
          width: number;
          height: number;
        }) => { width: number; height: number }
      >,
      required: true
    }
  },
  setup(props) {
    const iframeRef = ref<null | HTMLIFrameElement>(null);

    const resize = () =>
      props.onResize?.({
        width: iframeRef.value?.contentWindow?.innerWidth || 0,
        height: iframeRef.value?.contentWindow?.innerHeight || 0
      });

    watchEffect(() => {
      if (iframeRef.value) {
        iframeRef.value.contentWindow?.addEventListener("resize", resize);
      }
    });

    onMounted(() => resize());

    onBeforeUnmount(() => {
      if (iframeRef.value) {
        iframeRef.value.contentWindow?.removeEventListener("resize", resize);
      }
    });

    return { iframeRef };
  }
});
</script>

<style></style>
